import { render, staticRenderFns } from "./publicize.vue?vue&type=template&id=06719d90&scoped=true&"
import script from "./publicize.vue?vue&type=script&lang=js&"
export * from "./publicize.vue?vue&type=script&lang=js&"
import style0 from "./publicize.vue?vue&type=style&index=0&id=06719d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06719d90",
  null
  
)

export default component.exports